import { service } from '../axios';
export function saveRepairOrder(data) {
    return service({
        url: '/repair/saveRepairOrder',
        method: 'post',
        data,
    });
}
export function getRepairOrder(params) {
    return service({
        url: '/repair/getRepairOrder',
        method: 'get',
        params
    });
}
export function getRepairDetail(params) {
    return service({
        url: '/repair/getRepairDetail',
        method: 'get',
        params
    });
}
export function updateRepairExecution(data) {
    return service({
        url: '/repair/updateRepairExecution',
        method: 'post',
        data
    });
}
export function checkRepairInstrument(instrumentCode, repairNumber) {
    return service({
        url: '/repair/checkRepairInstrument',
        method: 'get',
        params: {
            instrumentCode,
            repairNumber
        }
    });
}
export function repairAcceptance(data) {
    return service({
        url: '/repair/repairAcceptance',
        method: 'post',
        data
    });
}
export function getMatchedFaultTypes(params) {
    return service({
        url: '/repair/getMatchedFaultTypes',
        method: 'get',
        params
    });
}
